module.exports = __webpack_public_path__ + "img/pitprojekt_logo_signin.ae89e104.svg";